'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["wrapperProps"];
import PropTypes from 'prop-types';
import SVGTextStyle from './SVGTextStyle';
import SVGWrapper from './SVGWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGText = props => {
  const {
      wrapperProps
    } = props,
    innerProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(SVGWrapper, Object.assign({}, wrapperProps, {
    children: /*#__PURE__*/_jsx(SVGTextStyle, Object.assign({}, innerProps))
  }));
};
SVGText.propTypes = {
  wrapperProps: PropTypes.any
};
export default SVGText;